/**
 * HyvaksyjanTaho.tsx — ulkopuolisen hyväksyjän nimi ja viite (ydin, T677 K; Toni 27.10.2026 klo 09.15).
 *
 * Kun hyväksyjän tahoksi valitaan ulkopuolinen (valvoja, suunnittelutoimisto, tilaajan edustaja), hyväksyneellä ihmisellä ei
 * ole tunnusta järjestelmässä: lomake kysyy hänen nimensä (pakollinen) ja viitteen (vapaaehtoinen, esim. sähköposti tai
 * pöytäkirjan numero). Kenttätyönjohdolta ei kysytä — kirjaaja on tunnettu. Palvelimen sääntö on api/src/hyvaksyja.ts.
 * Yhteinen komponentti punakynälle, linjatarkastuksen ja laippakiristyksen hyväksynnälle; virhe näytetään J:n säännöllä
 * (Kenttavirhe.tsx) nimikentän kohdalla.
 */
import type { ReactElement } from "react";
import { t } from "./kieli";
import { Kenttavirhe, type KenttavirheProps } from "./Kenttavirhe";

type Kentta = { ref?: (el: HTMLInputElement | null) => void; "aria-invalid"?: boolean; "aria-describedby"?: string };

/** «Tilaajan edustaja: Nimi» — taho ja ulkopuolisen nimi yhdessä; ilman nimeä pelkkä taho. */
export function hyvaksyjanEsitys(taho: string | null | undefined, nimi: string | null | undefined): string {
  if (!taho) return nimi ?? "";
  return nimi ? `${taho}: ${nimi}` : taho;
}

export default function HyvaksyjanTaho({ ulkopuolinen, nimi, viite, asetaNimi, asetaViite, nimiKentta, nimiVirhe, poisKaytosta, tiedosto, asetaTiedosto }: {
  ulkopuolinen: boolean;
  nimi: string; viite: string;
  asetaNimi: (s: string) => void; asetaViite: (s: string) => void;
  nimiKentta?: Kentta; nimiVirhe?: KenttavirheProps;
  poisKaytosta?: boolean;
  /** T679: valinnainen liitetiedosto (sähköposti, pöytäkirja); kutsuja lähettää sen hyväksyntärivin liitteeksi tallennuksen jälkeen. */
  tiedosto?: File | null; asetaTiedosto?: (f: File | null) => void;
}): ReactElement | null {
  if (!ulkopuolinen) return null;
  return (
    <>
      <label style={{ flex: "1 1 220px" }} data-ulkopuolinen-nimi="">{t("hyv.ulkopuolinen_nimi")}
        <input value={nimi} disabled={poisKaytosta} maxLength={200} {...nimiKentta}
               onChange={(e) => asetaNimi(e.target.value)} placeholder={t("hyv.ulkopuolinen_nimi_esim")} />
        {nimiVirhe && <Kenttavirhe {...nimiVirhe} />}
      </label>
      <label style={{ flex: "1 1 220px" }} data-ulkopuolinen-viite="">{t("hyv.viite")}
        <input value={viite} disabled={poisKaytosta} maxLength={300}
               onChange={(e) => asetaViite(e.target.value)} placeholder={t("hyv.viite_esim")} />
      </label>
      {asetaTiedosto && (
        <label style={{ flex: "1 1 220px" }} data-ulkopuolinen-liite="">{t("hyv.liite")}
          <input type="file" disabled={poisKaytosta} accept="application/pdf,image/*,.eml,.msg"
                 onChange={(e) => asetaTiedosto(e.target.files?.[0] ?? null)} />
          {tiedosto && <span className="dim">{tiedosto.name}</span>}
        </label>
      )}
    </>
  );
}
